<template lang="html">
  <div class="" id="myModal" :class='{"modal": true,"show": show, "hidden": !show}'>
    <div :class='{"modal-content": true, "fixed-width-modal": !config.buttons.decline.present}'>
      <span class="close" @click='close'>&times;</span>
      <h2>{{ config.header }}</h2>
      <main>
        <div v-if='config.type !== null'>
          <error v-if='config.type === "ERROR"'></error>
          <success v-if='config.type === "SUCCESS"'></success>
        </div>
        <div class="modal-body fix-height">
          <ul v-if='messageIsArray'>
            <li v-for='message in config.message'> {{ message }} </li>
          </ul>
          <p v-else='messageIsArray'>{{ config.message }}</p>
        </div>
      </main>
      <footer>
        <single-button
          v-if='!config.buttons.decline.present'
          :buttonText='config.buttons.accept.text'
          :error='error'
          :action='config.buttons.accept.action'
          v-model='result'>
        </single-button>
        <dual-buttons
          v-else
          :buttonText='config.buttons'
          :action='config.buttons.accept.action'
          v-model='result'>
        </dual-buttons>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as NameSpace from '../../../store/NameSpace'
import Error from '../logos/Error'
import Success from '../logos/Success'
import DualButtons from '../button-panel/DualButtons'
import SingleButton from '../button-panel/SingleButton'

export default {
  props: ['value'],
  components: {
    Error,
    Success,
    DualButtons,
    SingleButton
  },
  data () {
    return {
      result: null,
      show: false
    }
  },
  methods: {
    close () {
      this.show = false
    },
    setModalResponse (data) {
      this.actionSetModalResponse(data)
    },
    ...mapActions({
      actionSetModalResponse: NameSpace.SET_MODAL_RESPONSE_ACTION
    })
  },
  watch: {
    result () {
      if (this.result !== null) {
        this.show = false
        this.setModalResponse(this.result)
        this.$emit('input', this.result)
      } else if (this.result === '') {
        this.show = false
        this.$emit('input', this.result)
      }
      this.result = null
    },
    config () {
      this.show = true
    }
  },
  computed: {
    ...mapGetters({
      config: NameSpace.MODAL_CONFIG_GETTER
    }),
    error () {
      return this.config.type === 'ERROR'
    },
    messageIsArray () {
      return Array.isArray(this.config.message)
    }
  }
}
</script>

<style lang="css"  scoped>
  .fix-height {
    max-height: 200px;
    overflow-y: auto;
    /*border-top: 1px solid #f8eeee;*/
  }
.modal {
  position: relative;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
  height: 100%;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
}
.modal-content{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 1.5rem;
  min-width: 25%;
  background-color: #fefefe;
  border-radius: 0.3rem;
  box-shadow: 0 0 .5rem #eee;
}
.fixed-width-modal {
  /*width: 25%;*/
}
.close {
  position: absolute;
  top: 0;
  right: 1.1rem;
  font-size: 2.8rem;
  cursor: pointer;
  color: #aaa;
  font-weight: bold;
}
.close:hover, .close:focus {
  color: red;
  text-decoration: none;
  cursor: pointer;
}

header {
  text-align: center;
}

h2 {
  margin-top: 0;
  text-transform: uppercase;
  font-size: 2.8rem;
  text-align: center;
}

.show {
  visibility: visible;
  opacity: 1;
  z-index: 100;
  transition: opacity 0.5s ease-out, visibility 0.5s ease-out, z-index 0.5s ease-out;
}

.hidden {
  opacity: 0;
  visibility: hidden;
  z-index: 0;
  transition: opacity 0.5s ease-out, visibility 0.5s ease-out, z-index 0.5s ease-out;
}

.modal-body {
  text-align: center;
  font-size: 1.4rem;
}

ul {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// Modal.vue?860a2424